export default __webpack_public_path__ + "static/banner-the-hunt-for-a-reliable-car-what-matters-5c8319060c3857e4e35266951539cfb5.jpg";